<h5 class="font-weight-bold mt-2">{{ 'ProjectsDashboard.summary.title' | translate }}</h5>

@if (project(); as projectData) {
  <div class="row mt-4">
    <div class="col-md-6">
      <div class="dashboard-card">
        <div class="dashboard-card__header">
          <h5>{{ 'ProjectsDashboard.summary.projectData.title' | translate }}</h5>
          <svg-icon src="./assets/img/ic-edit-v2.svg" (click)="editProject()" />
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="dashboard-card__details">
              <div class="details-title">
                {{ 'ProjectsDashboard.summary.projectData.created' | translate }}
              </div>
              <div class="details-content">
                {{ projectData.created ? (projectData.created | date: 'dd.MM.yyyy HH:mm') : '-' }}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="dashboard-card__details">
              <div class="details-title">
                {{ 'ProjectsDashboard.summary.projectData.address' | translate }}
              </div>
              <div class="details-content">
                @if (projectData.fullAddress) {
                  {{ projectData.address || '-' }}<br />
                  {{ projectData.postalCode || '' }} {{ projectData.town || '' }}
                } @else {
                  -
                }
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <div class="dashboard-card__details">
              <div class="details-title">{{ 'ProjectsDashboard.summary.projectData.area' | translate }}</div>
              <div class="details-content">{{ projectData.basicDataBox?.area || '-' }} {{ 'm²' }}</div>
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <div class="dashboard-card__details">
              <div class="details-title">{{ 'ProjectsDashboard.summary.projectData.floor' | translate }}</div>
              <div class="details-content">{{ projectData.basicDataBox?.floor || '-' }}</div>
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <div class="dashboard-card__details">
              <div class="details-title">
                {{ 'ProjectsDashboard.summary.projectData.nameOnDoorBell' | translate }}
              </div>
              <div class="details-content">{{ projectData.basicDataBox?.nameOnDoorbell || '-' }}</div>
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <div class="dashboard-card__details">
              <div class="details-title">
                {{ 'ProjectsDashboard.summary.projectData.realizationTerm' | translate }}
              </div>
              <div class="details-content">
                @if (projectData.basicDataBox?.termStart || projectData.basicDataBox?.termEnd) {
                  {{
                    projectData.basicDataBox?.termStart
                      ? (projectData.basicDataBox?.termStart | date: 'dd.MM.yyyy')
                      : '-'
                  }}
                  -
                  {{
                    projectData.basicDataBox?.termEnd
                      ? (projectData.basicDataBox?.termEnd | date: 'dd.MM.yyyy')
                      : '-'
                  }}
                } @else {
                  -
                }
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <div class="dashboard-card__details">
              <div class="details-title">
                {{ 'ProjectsDashboard.summary.projectData.budget' | translate }}
              </div>
              <div class="details-content details-content--budget">
                @if (
                  projectData.basicDataBox?.budgetAmount !== null &&
                  projectData.basicDataBox?.budgetAmount !== undefined
                ) {
                  <span class="budget-value" [class.budget-value--hidden]="!isBudgetVisible()">
                    {{ projectData.basicDataBox?.budgetAmount | priceFormat: true }}
                    {{ getCurrency(projectData.basicDataBox?.budgetType) }}
                  </span>
                  <svg-icon
                    class="budget-toggle-btn"
                    [src]="isBudgetVisible() ? '/assets/img/ic-eye-off.svg' : '/assets/img/eye-icon.svg'"
                    (click)="toggleBudgetVisibility()"
                  />
                } @else {
                  -
                }
              </div>
            </div>
          </div>
        </div>

        <div class="dashboard-card__divider"></div>

        <div class="row">
          <div class="col-12">
            <div class="dashboard-card__details">
              <div class="details-title">
                {{ 'ProjectsDashboard.summary.projectData.responsibleEmployee' | translate }}
              </div>
              @let responsibleEmployee = projectData.basicDataBox?.responsibleEmployee;

              @if (responsibleEmployee) {
                <div class="details-content details-content--copyable mb-1">
                  <span>{{ responsibleEmployee.userPerson?.previewName || '-' }}</span>
                  <svg-icon
                    class="copy-icon"
                    src="/assets/img/ic-copy_to_clipboard_blue.svg"
                    (click)="
                      copyContactData(
                        responsibleEmployee.userPerson?.previewName,
                        responsibleEmployee.userPerson?.fullPhone,
                        responsibleEmployee.userPerson?.email
                      )
                    "
                  />
                </div>
                <div class="details-content mb-1">
                  {{ responsibleEmployee.userPerson?.fullPhone || '-' }}
                </div>
                <div class="details-content">
                  {{ responsibleEmployee.userPerson?.email || '-' }}
                </div>
              } @else {
                <div class="details-content">-</div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="dashboard-card">
        <div class="dashboard-card__header">
          <h5>{{ 'ProjectsDashboard.summary.customerData.title' | translate }}</h5>
          <svg-icon src="./assets/img/ic-edit-v2.svg" (click)="editMainContact()" />
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="dashboard-card__details">
              <div class="details-title">
                {{ 'ProjectsDashboard.summary.customerData.clientData' | translate }}
              </div>
              <div class="details-content">
                {{ projectData.MainContact?.fullName || '-' }}
                <svg-icon
                  class="cursor-pointer ml-1"
                  [src]="'/assets/img/ic-external-link.svg'"
                  [permission]="{
                    group: PermissionsGroups.CONTACTS,
                    action: 'PREVIEW'
                  }"
                  [svgStyle]="{ width: '14px', height: '14px' }"
                  (click)="contactPreview()"
                />
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="dashboard-card__details">
              <div class="details-title">
                {{ 'ProjectsDashboard.summary.customerData.address' | translate }}
              </div>
              <div class="details-content">{{ projectData.MainContact?.fullAddress || '-' }}</div>
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <div class="dashboard-card__details">
              <div class="details-title">
                {{ 'ProjectsDashboard.summary.customerData.email' | translate }}
              </div>
              <div class="details-content details-content--copyable">
                <span>{{ projectData.MainContact?.email || '-' }}</span>
                @if (projectData.MainContact?.email) {
                  <svg-icon
                    class="copy-icon"
                    src="/assets/img/ic-copy_to_clipboard_blue.svg"
                    (click)="copyValue(projectData.MainContact?.email)"
                  />
                }
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <div class="dashboard-card__details">
              <div class="details-title">
                {{ 'ProjectsDashboard.summary.customerData.phone' | translate }}
              </div>
              <div class="details-content details-content--copyable">
                <span>{{ projectData.MainContact?.fullPhone || '-' }}</span>
                @if (projectData.MainContact?.fullPhone) {
                  <svg-icon
                    class="copy-icon"
                    src="/assets/img/ic-copy_to_clipboard_blue.svg"
                    (click)="copyValue(projectData.MainContact?.fullPhone)"
                  />
                }
              </div>
            </div>
          </div>
        </div>

        <div class="dashboard-card__divider"></div>

        <div class="row">
          <div class="col-12">
            <div class="dashboard-card__details">
              <div class="details-title">
                {{ 'ProjectsDashboard.summary.customerData.responsibleContact' | translate }}
              </div>
              @let responsibleContact = projectData.basicDataBox?.responsibleContact;

              @if (responsibleContact) {
                <div class="details-content details-content--copyable mb-1">
                  <span>{{ responsibleContact.fullName || '-' }}</span>
                  <svg-icon
                    class="copy-icon"
                    src="/assets/img/ic-copy_to_clipboard_blue.svg"
                    (click)="
                      copyContactData(
                        responsibleContact.fullName,
                        responsibleContact.fullPhone,
                        responsibleContact.email
                      )
                    "
                  />
                </div>
                <div class="details-content mb-1">
                  {{ responsibleContact.fullPhone || '-' }}
                </div>
                <div class="details-content">
                  {{ responsibleContact.email || '-' }}
                </div>
              } @else {
                <div class="details-content">-</div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 mt-4">
      <project-summary-documents />
    </div>
  </div>
} @else {
  <div class="d-flex align-items-center justify-content-center my-5">
    <div class="lds-dual-ring"></div>
  </div>
}
